import React from 'react';

import { StarFull } from '@travel/icons/ui';

import { StarPartial } from './starPartial';

import cx from '../../utils/classnames';

import styles from './starRating.module.scss';

type Props = {
  /** Custom style for wrapper */
  className?: string;
  /** Star rating to be displayed */
  rating: number;
  /** Icon size of the star to be displayed */
  size?: 16 | 24 | 32 | 48;
  /** ARIA label for rating */
  ariaLabel?: string;
};

export default function StarRating(props: Props) {
  const { className = '', rating, size = 24, ariaLabel, ...rest } = props;
  const ratingInt = Math.floor(rating);
  const ratingDecimal = rating % 1;
  const starList: Array<React.ReactNode> = [];
  for (let index = 0; index < ratingInt; index += 1) {
    starList.push(<StarFull key={index} size={size} />);
  }
  return (
    <div
      data-testid="starRating-wrapper"
      className={cx(className, styles.starContainer)}
      aria-label={ariaLabel}
      {...rest}
    >
      {starList}
      {ratingDecimal > 0 && <StarPartial rating={ratingDecimal} size={size} />}
    </div>
  );
}
